import * as React from "react";
import { singleton } from "logic/singleton";
const MessageSummaryTemplateContext = React.createContext(void 0);
export default singleton("contexts.MessageSummaryTemplate", () => MessageSummaryTemplateContext);
